export const OVERLAY_ALIGN_OPTIONS = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  JUSTIFY: "justify",
};

export const OVERLAY_EDGE_INSET = 24;
export const CONTAINER_ALIGN_INSET = 0;

export const getOverlayLayoutStyle = ({
  align = OVERLAY_ALIGN_OPTIONS.CENTER,
  offsetX = 0,
  offsetY = 0,
  width,
  height,
  canvasWidth,
} = {}) => {
  const ox = Number(offsetX) || 0;
  const oy = Number(offsetY) || 0;
  const authoredCanvasWidth = Number(canvasWidth);

  if (align === OVERLAY_ALIGN_OPTIONS.JUSTIFY) {
    return {
      left: OVERLAY_EDGE_INSET,
      right: OVERLAY_EDGE_INSET,
      width: "auto",
      ...(height != null ? { height } : {}),
      transform: `translateY(${oy}px)`,
    };
  }

  const sizeStyle = {};
  if (width != null) sizeStyle.width = width;
  if (height != null) sizeStyle.height = height;

  if (align === OVERLAY_ALIGN_OPTIONS.LEFT) {
    return {
      ...sizeStyle,
      left: OVERLAY_EDGE_INSET,
      right: "auto",
      transform: `translate(${ox}px, ${oy}px)`,
    };
  }

  if (align === OVERLAY_ALIGN_OPTIONS.RIGHT) {
    return {
      ...sizeStyle,
      left: `calc(100% - ${OVERLAY_EDGE_INSET}px)`,
      right: "auto",
      transform: `translate(calc(-100% + ${-ox}px), ${oy}px)`,
    };
  }

  const centerLeft =
    Number.isFinite(authoredCanvasWidth) && authoredCanvasWidth > 0
      ? `max(${authoredCanvasWidth / 2}px, 50%)`
      : "50%";

  return {
    ...sizeStyle,
    left: centerLeft,
    right: "auto",
    transform: `translate(calc(-50% + ${ox}px), ${oy}px)`,
  };
};

export const mapAlignToTextAlign = (align) => {
  if (align === OVERLAY_ALIGN_OPTIONS.LEFT) return "left";
  if (align === OVERLAY_ALIGN_OPTIONS.RIGHT) return "right";
  if (align === OVERLAY_ALIGN_OPTIONS.JUSTIFY) return "justify";
  if (align === OVERLAY_ALIGN_OPTIONS.CENTER) return "center";
  return undefined;
};
